const weights = {
  200: ' Extra Light',
  300: ' Light',
  400: ' Regular',
  500: ' Medium',
  600: ' Semi Bold',
  700: ' Bold',
  800: ' Extra Bold',
  900: ' Black',
};

const styles = {
  normal: '',
  italic: ' Italic',
};

export const getFontWeight = (weightString) => {
  if (weightString === 'bold') return '800';
  if (weightString === 'normal') return '400';

  const weightStringLower = weightString.toLowerCase();
  return Object.keys(weights).find((key) => weights[key].toLowerCase() === ` ${weightStringLower}`);
};

export const fontsEqual = (font, family, style, weight) => {
  return font.family === family && font.style === style && font.weight === weight;
};

export const getFontName = (font, style, weight) => {
  let weightStr = weights[weight];
  if (font.weights.length > 1) {
    weightStr = ` -${weightStr}`;
  } else if (style === 'italic') {
    weightStr = ` -${weightStr}`;
  } else {
    weightStr = '';
  }
  return `${font.family}${weightStr}${styles[style]}`;
};

export const mapFabricFontToLocal = (selFont) => {
  if (!window.fonts || !selFont) return null;
  for (const font of window.fonts) {
    if (font.family === selFont.fontFamily) {
      let weight = selFont.fontWeight;
      if (weight === 'bold') weight = '800';
      else if (weight === 'normal') weight = '400';
      if (font.weights.includes(weight) && font.styles.includes(selFont.fontStyle)) {
        const name = getFontName(font, selFont.fontStyle, weight);
        return {
          name,
          family: selFont.fontFamily,
          style: selFont.fontStyle,
          weight: selFont.fontWeight,
        };
      }
      return null;
    }
  }
  return null;
};
